import { render, staticRenderFns } from "./AllDisputesTable.vue?vue&type=template&id=3a1f5433&scoped=true&"
import script from "./AllDisputesTable.vue?vue&type=script&lang=js&"
export * from "./AllDisputesTable.vue?vue&type=script&lang=js&"
import style0 from "./AllDisputesTable.vue?vue&type=style&index=0&id=3a1f5433&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f5433",
  null
  
)

export default component.exports